<template>
  <div>
    <div></div>
    <!-- Split Merge Summary Modal Start -->
    <h6 variant="danger" @click="SplitMergeSummary()">
      <b-badge :variant="Status==2?'success':'danger'">{{Status==2?'Container Details':'Split Activated'}}</b-badge>
    </h6>
    <b-modal
      id="SplitMergeSummary-modal"
      ref="SplitMergeSummary-modal"
      :title="title + SM_jb_series"
      size="xl"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <div class="row">
        <div
          class="col-md-12 row"
          v-if="containerDetails.length > 0"
        >
          <table class="table table-sm table-bordered">
            <tbody>
              <tr>
                <th scope="col">SN.</th>
                <th scope="col">Container Type</th>
                <th scope="col">Container No</th>
                <th scope="col">Status</th>
              </tr>
              <tr v-for="(itm, idx) in containerDetails" :key="idx">
                <th>{{idx+1}}</th>
                <td>{{ itm.containerType }}</td>
                <td>{{ itm.containerNo }}</td>
                <td>
                  <span v-if="itm.splitedToOrMergedToAssigNo" class="error"
                    >Container Moved From :{{ itm.fromSplitMergeAssignNo }} to :
                    {{ itm.splitedToOrMergedToAssigNo }} (<b
                      v-if="itm.isSplitedOrMergedNew == 1"
                    >
                      Splited</b
                    ><b v-else-if="itm.isSplitedOrMergedNew == 2"> Merged</b
                    ><b v-else-if="itm.isSplitedOrMergedNew == 3">Moved</b>)
                    Updated Date({{ itm.split_merge_date_time }})</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <b-button
        @click="hideSplitMergeSummary"
        variant="danger"
        class="pull-right"
      >
        Close</b-button
      >
    </b-modal>
    <!-- Assignment Summary Modal End -->
  </div>
</template>


<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation,
} from "../../helper/collection";

export default {
  props: ["title", "SM_all_module_id", "SM_jb_series","SM_Status"],
  beforeMount() {
    if (this.SM_all_module_id != "" && this.Filter_Flag == true) {
      this.fetchSMData();
    }
  },

  data() {
    return {
      all_module_id: this.SM_all_module_id,
      Status:this.SM_Status,
      Filter_Flag: false,
      containerDetails: [],
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    Loading,
    DatePicker,
    ModelListSelect,
  },

  computed: {},
  watch: {},
  methods: {
    SplitMergeSummary() {
      this.Filter_Flag = true;
      this.$refs["SplitMergeSummary-modal"].show();
      this.fetchSMData();
    },
    hideSplitMergeSummary() {
      this.Filter_Flag = false;
      this.$refs["SplitMergeSummary-modal"].hide();
    },
    fetchSMData() {

      if (this.Filter_Flag == true) {
        let new_data = {
          itemCode: "itemCode",
          allModuleId: this.SM_all_module_id,
          Status:this.Status,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Common/fetchSplitMergeContainerData.php`,
          data: JSON.stringify(new_data),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.containerDetails = [];

              if (data.containerDetails.length > 0) {
                this.containerDetails = data.containerDetails;
              }
            }
          })
          .catch((error) => {});
      }
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>


// WEBPACK FOOTER //
// splitmergeSummary.vue?667fbfe4